export default __webpack_public_path__ + "static/media/tablePreview_3.b8f8428c.png";